import { useEffect, useState } from "react";
import { Scale, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { karsiVekaletPending } from "@/lib/api";
import { formatTRY, mahkemeTuruLabel } from "@/lib/constants";

export default function KarsiVekaletTakip({ cases, onSelectCase, mahkemeTuru, refreshKey }) {
  const [data, setData] = useState({ items: [], toplam: 0, count: 0 });

  useEffect(() => {
    karsiVekaletPending(mahkemeTuru).then(setData).catch(() => {});
  }, [mahkemeTuru, refreshKey]);

  if (!data.count) return null;

  return (
    <Card className="bg-slate-900/70 border-amber-900/40" data-testid="karsi-vekalet-takip">
      <CardContent className="p-5">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Scale className="w-5 h-5 text-amber-500" />
            <div className="font-serif text-lg text-slate-100">Karşı Vekalet İcra Takibi</div>
            <Badge variant="outline" className="border-amber-700/50 text-amber-400 ml-1">
              {data.count} dava
            </Badge>
          </div>
          <div className="text-right">
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">
              Beklenen Toplam
            </div>
            <div className="font-serif text-xl text-amber-400 font-semibold font-mono">
              {formatTRY(data.toplam)}
            </div>
          </div>
        </div>

        <div className="border border-slate-800 rounded overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-900/80 text-slate-400 text-[11px] uppercase tracking-wider">
              <tr>
                <th className="px-3 py-2 text-left">Dava No</th>
                <th className="px-3 py-2 text-left">Mahkeme / Tür</th>
                <th className="px-3 py-2 text-left">Karşı Taraf</th>
                <th className="px-3 py-2 text-right">Tutar</th>
                <th className="px-3 py-2 w-10"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800">
              {data.items.slice(0, 10).map((it, i) => (
                <tr
                  key={it.case_id}
                  className="hover:bg-amber-950/20 cursor-pointer"
                  onClick={() => {
                    const c = cases.find((x) => x.id === it.case_id);
                    if (c) onSelectCase(c);
                  }}
                  data-testid={`karsi-vekalet-row-${i}`}
                >
                  <td className="px-3 py-2 font-mono text-slate-200">{it.dava_no}</td>
                  <td className="px-3 py-2">
                    <div className="text-slate-300 text-xs truncate max-w-[220px]">{it.mahkeme_adi}</div>
                    <Badge variant="outline" className="border-slate-700 text-slate-500 text-[10px] mt-0.5">
                      {mahkemeTuruLabel(it.mahkeme_turu)}
                    </Badge>
                  </td>
                  <td className="px-3 py-2 text-slate-400 text-xs truncate max-w-[180px]">
                    {it.karsi_taraf || "—"}
                  </td>
                  <td className="px-3 py-2 text-right font-mono text-amber-400">{formatTRY(it.tutar)}</td>
                  <td className="px-3 py-2 text-slate-600"><ChevronRight className="w-4 h-4" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {data.count > 10 && (
          <div className="text-[11px] text-slate-500 mt-2 italic">
            +{data.count - 10} dava daha…
          </div>
        )}
      </CardContent>
    </Card>
  );
}
